import React, { useState, useContext, useEffect } from 'react';
import { Form, Typography } from 'antd';
import { MCPResearchContext } from '../../MCPResearchUI';

const { Text } = Typography;

const EditText = ({ fieldName, text }) => {
    const formName = ['basicDetails', fieldName];

    const { form } = useContext(MCPResearchContext);
    const [editText, setEditText] = useState(text);
    useEffect(() => {
        setEditText(text);
    }, [text]);

    const onEdit = async (editedText) => {
        form.setFieldValue(formName, editedText);
        setEditText(editedText);
    };

    return (
        <Form.Item name={formName}>
            <Text editable={{ onChange: onEdit, text: editText }}>
                <Link link={editText} />
            </Text>
        </Form.Item>
    );
};

const Link = ({ link }) => {
    if (!link || link === 'NA' || link.startsWith('http') === false) {
        return <Text>{link}</Text>;
    }
    return (
        <a target='_blank' href={link}>
            {link}
        </a>
    );
};

export default EditText;
